import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthenticatedApi } from '../api';
import {
  flushActivityQueue,
  setMemberActivitySender,
  startMemberActivityFlushInterval,
} from '../utils/memberActivity';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function MemberActivityReporter() {
  const { isAuthenticated, isLoading } = useAuth0();
  const { authenticatedFetch } = useAuthenticatedApi();

  useEffect(() => {
    if (isLoading || !isAuthenticated) {
      setMemberActivitySender(null);
      return undefined;
    }

    const sender = async (events) => {
      const payload = events.map(({ kind, action, path, category, label, detail }) => ({
        kind,
        action,
        path: path ?? null,
        category: category ?? null,
        label: label ?? null,
        detail: detail ?? null,
      }));

      const response = await authenticatedFetch(`${API_BASE}/members/activity`, {
        method: 'POST',
        body: JSON.stringify({ events: payload }),
      });

      if (!response.ok) {
        throw new Error(`Activity log failed (${response.status})`);
      }
    };

    setMemberActivitySender(sender);
    const stopInterval = startMemberActivityFlushInterval();

    return () => {
      setMemberActivitySender(null);
      stopInterval?.();
      void flushActivityQueue();
    };
  }, [isAuthenticated, isLoading, authenticatedFetch]);

  return null;
}
